import { Component } from 'react';
import { connect } from 'react-redux';
import { ReactComponent as Add } from 'assets/images/svg/add.svg';
import { validator } from 'Helpers/validator';
import { broadCastActions, TeamAction } from 'Actions';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import LoadingOverlay from 'react-loading-overlay';
import { Multiselect } from 'multiselect-react-dropdown';
import formUrlParams from 'Helpers/urlform';
import { broadCastConstant } from 'Constants/adminBroadCast.constants';

let timeout = null;

class AddManageBroadcast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      sendType: '',
      message: '',
      isMedia: '',
      messageType: 'text',
      team: '',
      teamSelect: [],
      teamList: [],
      teamLoading: false,
      filtered: [],
      teamSelectError: false,
      broadcastUserType:broadCastConstant.BROADCAST_USER_TYPE_TEAM
      /* publishmessages: '',
      schedulemessages: '',
      publishmessagesType: '',
      schedulemessagesType: '',
      publishBy: '',
      scheduleBy: '',
      publishteamName: '',
      scheduleteamName: '',
      createdBy: {
        name: '',
        image: ''
      },
      createdDateTime: 0,
      broadcastDateTime: '',
      deliveryStatus: '',
      status: 1,
      fileName: '',
      publishimage: '',
      scheduleimage: '',
      publishisActive:1,
      scheduleisActive:1,
      image:'' */
    };
    this.validator = validator.getInstance();
    this.formSubmit = false;
  }

  componentDidMount() {
    this.props.fetchTeam();
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.totalRecords !== this.props.totalRecords) {
      if( this.props.error !== true && this.props.errorElement === '' ) {  
        document.getElementById('addbroadcast-form') && 
        document.getElementById('addbroadcast-form').reset();
        this.closeBroadCastMenu();
      } 
    }  
    if (prevProps.errorElement !== this.props.errorElement) {
      this.setState({ errorElement: this.props.errorElement });
    }
    
    const { teamData: { id: teamDataId = '', responseArray: teamArray } } = this.props;
    const { teamData: { id: prevTeamDataId = '' } } = prevProps;
    if(teamDataId !== prevTeamDataId) {
      const teams = [];
      teamArray.map(res => {
        const { id, teamName } = res;
        teams.push({ id, name: teamName })
      });
      this.setState({
        teamList: teams
      });
    }
  }

  validation = e => {
    if (!e.target.dataset.validation || !e.target.dataset.check) {
      return;
    }
    const inputRules = e.target.dataset.validation.split(',');
    const elementObject = {
      formId: 'addbroadcast',
      elementName: e.target.name,
      elementValue: e.target.value,
      message: e.target.dataset.error
    };
    this.validator.validate(elementObject, inputRules);
  };

  handleChange = e => {
    const { name, value } = e.target;
    if((name === 'sendType' && value?.length > broadCastConstant.BROADCAST_MSG_TYPE_CHAR_LENGTH) || (name === 'message' && value?.length > broadCastConstant.BROADCAST_MSG_CHAR_LENGTH)){
      return;
    }
    this.setState({ [ name ]: value });
  };

  handleSelectTeam = e => {
    const value = [ e.target.value ];//target.options[ e.target.selectedIndex ].dataset.rolename;
    const { name } = e.target;
    this.setState({ [ name ]: value });
  };

  /* handleSelectPublishBy = e => {
    const value = e.target.options[ e.target.selectedIndex ].dataset.rolename;
    const { name } = e.target;
    this.setState({ [ name ]: value });
  };

  handlescheduleCheckBoxChange = () => {
    this.setState({ scheduleisActive: !this.state.scheduleisActive & 0 });
  };
  handlePublishCheckBoxChange = () => {
    this.setState({ publishisActive: !this.state.publishisActive & 0 });
  }; */

  renderTeamName = () => {
    const { teamData: { responseArray: teamNameArray } = {} }  = this.props;
    return teamNameArray.map((team, index) => {
      return (
        <option data-rolename={ team.teamName } key={ team.id } value={ team.id }>
          { team.teamName }
        </option>
      );
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    if(this.formSubmit){
      return;
    }
    this.formSubmit = true;
    const { 
      sendType, message, messageType, team, broadcastUserType
    } = this.state;
    const eventId = event.target.id;
    let teamSelectError = false;
    if(broadcastUserType === broadCastConstant.BROADCAST_USER_TYPE_TEAM){
      teamSelectError = team === '' ? true : false;
    }
    this.setState({
      teamSelectError
    }, () => {
      const formData = {
        // teamIds: [ team ],
        broadcastUserType,
        ...( broadcastUserType === broadCastConstant.BROADCAST_USER_TYPE_TEAM ? { teamIds: [ team ] } : {} ),
        messageObj: {
          messageType: messageType,
          message: message,
          sendType: sendType
        }
      }
      
      if (eventId && !this.validator.checkBeforeSubmit(eventId) && !this.state.teamSelectError) {
        this.props.addBroadCast(formData);
      }
      else{
        this.formSubmit = false;
      }
    });
  };

  closeBroadCastMenu = () => {
    this.props.closeBroadCastMenu();
  };

  formUrlParams = (name, value) => {
    const { filtered } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse }, () => {
      this.props.fetchTeam(this.state.filtered);
    });
  };

  handleTeam = (team = []) => {
    const teamSelect = team && team[ team.length - 1 ];
    this.setState({ team: teamSelect.id, teamSelect: [ teamSelect ] }, () => {
      this.handleTeamPlaceholder('');
    });
  }

  handleTeamRemove = () => {
    const filtered = this.state.filtered.filter( el => el.id !== 'teamSearch' );
    this.setState({ team: '', teamSelect: [], filtered: filtered }, () => {
      this.handleTeamPlaceholder('Select');
    });
  }

  handleTeamPlaceholder = (text) => {
    const element = document.getElementById('search_input');
    element.setAttribute('placeholder', text)
  }

  handleTeamSearch = (toSearch = '') => {
    this.setState({ searchVal: toSearch, teamLoading: true })
    if(toSearch.length >= 1) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        return this.formUrlParams('teamNameSearch', toSearch);;
      }, 700)
    }
    return this.setState({ teamLoading: false });
  }

  render() {
    const { 
      sendType, message, teamList, teamSelect, teamLoading, teamSelectError, broadcastUserType
    } = this.state;
    const { loading } = this.props;
    return (
      <>
        <div className='addbroadcast1 addadmin' id='addbroadcast'>
          <div className='overlay' onClick={ this.closeBroadCastMenu }></div>
          <div className='addmgnt' id='broadcast-form1'>
            <LoadingOverlay
              active={ loading }
              spinner
              styles={ {
                wrapper: {
                  width: '100%',
                  textAlign: '-webkit-center',
                },
              } }
              text='Please wait...'
            ></LoadingOverlay>
            <Tabs>
              <TabPanel>
                <div className='head'>
                  <h2>New Broadcast</h2>
                </div>
                <form id='addbroadcast-form' onSubmit={ this.handleSubmit }>
                  <div className='ctInputField'>
                    <label>
                      Message Type<sup>*</sup>
                    </label>
                    <input
                      type='text'
                      name='sendType'
                      value={ sendType }
                      data-length={ 100 }
                      data-validation={ [ 'requiredfield,maxlength' ] }
                      data-error='Enter message type'
                      placeholder='Enter message type here!'
                      onBlur={ this.validation }
                      onChange={ this.handleChange }
                      maxLength={ broadCastConstant.BROADCAST_MSG_TYPE_CHAR_LENGTH }
                    />
                  </div>
                  <div className='ctInputField'>
                    <label>Message<sup>*</sup></label>
                    <input
                      type='text'
                      name='message'
                      value={ message }
                      data-length={ 100 }
                      data-validation={ [ 'requiredfield,maxlength' ] }
                      data-error='Enter message'
                      placeholder='Enter message here!'
                      onBlur={ this.validation }
                      onChange={ this.handleChange }
                      maxLength={ broadCastConstant.BROADCAST_MSG_CHAR_LENGTH }
                    />
                  </div>
                  { false && <div className='ctRadioField'>
                    <label>
                      Select User Type<sup>*</sup>
                    </label>
                    <div className='radio_box'>
                      <label for="broadcastUserType-all">
                      <input
                        type='radio'
                        name='broadcastUserType'
                        value={ broadCastConstant.BROADCAST_USER_TYPE_ALL }
                        id="broadcastUserType-all"
                        style={ { appearance:'auto' } }
                        onChange={ this.handleChange }
                        checked={ broadcastUserType === broadCastConstant.BROADCAST_USER_TYPE_ALL }
                      /><span>All users</span>
                      </label>
                    </div>
                    <div className='radio_box'>
                      <label for="broadcastUserType-team">
                        <input
                          type='radio'
                          name='broadcastUserType'
                          value={ broadCastConstant.BROADCAST_USER_TYPE_TEAM }
                          id="broadcastUserType-team"
                          style={ { appearance:'auto' } }
                          onChange={ this.handleChange }
                          checked={ broadcastUserType === broadCastConstant.BROADCAST_USER_TYPE_TEAM }
                        /><span>Select Team</span>
                      </label>
                      <input
                        type='text'
                        name='selectUserType'
                        value={ broadcastUserType }
                        data-validation={ [ 'requiredfield' ] }
                        data-error='Select user type'
                        onBlur={ this.validation }
                        style={ { appearance:'auto', display:'none' } }
                        // onChange={ this.handleChange }
                      />
                    </div>
                  </div>
                  }
                  {broadcastUserType === broadCastConstant.BROADCAST_USER_TYPE_TEAM && 
                  <div className='formgroup_multi new'>
                    <label>
                      Select Team<sup>*</sup>
                    </label>
                    <Multiselect
                      options={ teamList } // Options to display in the dropdown
                      selectedValues={ teamSelect } // Preselected value to persist in dropdown
                      onSelect={ this.handleTeam } // Function will trigger on select event
                      onRemove={ this.handleTeamRemove } // Function will trigger on remove event
                      displayValue="name" // Property name to display in the dropdown options
                      onSearch={ this.handleTeamSearch }
                      loading = { teamLoading }
                    />
                    { teamSelectError && <span id="team-requiredfield" class="error">Select team</span> }
                  </div>
                  }
                  <div className='buttons'>
                    <div>
                      <button
                        type='reset'
                        onClick={ this.closeBroadCastMenu }
                        className='btn btn_outline'
                      >
                        Cancel
                      </button>
                      <button className='btn btn_primary'>Save</button>
                    </div>
                  </div>
                </form>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchtoProps = {
  addBroadCast: broadCastActions.addBroadCast,
  fetchTeam: TeamAction.fetchTeam,
};

function mapStateToProps(state) {
  return { 
    ...state.broadCast,
    teamData: state.team,
  };
}
export default connect(mapStateToProps, mapDispatchtoProps)(AddManageBroadcast);
